export interface UserItem {
  username: string;
  uuid: string;
}
export interface SdkConfig {
  id?: number,
  roomId?: string,
  sdkappid?: string,
  users?: [];
  password?: string;
  orgName?: string;
  apiUrl?: string;
  appName?: string;
  groupId?: string;
  socketUrl?: string;
  appKey?: string;
  username?: string;
  [key: string]: undefined | string | number | boolean | object;
}

export interface ChatItemType {
  id: string,
  type: string,
  contentsType: string,
  from: string,
  to: string,
  data?: string,
  ext: {},
  sourceMsg?: string,
  time: string,
  msgConfig: string | number | boolean | object | undefined,
  error: boolean,
  errorText: string,
  errorCode: number,
  message_type: string,
  source: string;
  [key: string]: undefined | string | number | boolean | object;
}
export interface ImsState {
  timIsReady: boolean;
  timIsGroupReady: boolean;
  timSdkConfig: SdkConfig;
  triggerScroll: boolean;
  userInfo: UserItem;
  timGroupChat: {
    list: ChatItemType[];
    groupPhotoList: ChatItemType[];
    isMore: boolean;
    lastMessageTime?: string | number;
    nextReqMessageID?: string | number;
  };
}

export enum ImActionTypes {
  /* 腾讯 tim */
  TIMSDK_DATA_DYNAMIC_UPDATE = 'TIMSDK_DATA_DYNAMIC_UPDATE',
  TIMSDK_LOGOUT = 'TIMSDK_LOGOUT',
  TIMSDK_UPDATE_CONFIG = 'TIMSDK_UPDATE_CONFIG',
  TIMSDK_RECEIVEMESSAGE = 'TIMSDK_RECEIVEMESSAGE',
  TIMSDK_GET_GROUPLIST = 'TIMSDK_GET_GROUPLIST',
  TIMSDK_GET_HISTORY_MESSAGELIST = 'TIMSDK_GET_HISTORY_MESSAGELIST',
  TIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST = 'TIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST',
  TIMSDK_RECEIVE_MESSAGE_SCROLL = 'TIMSDK_RECEIVE_MESSAGE_SCROLL',

  TIMSDK_SEND_IMTXT_MESSAGE = 'TIMSDK_SEND_IMTXT_MESSAGE',
  TIMSDK_SEND_IMIMAGE_MESSAGE = 'TIMSDK_SEND_IMIMAGE_MESSAGE',
  TIMSDK_UPDATE_MESSAGE_STATUS = 'UMP_UPDATE_MESSAGE_STATUS',

  /* 网易云 nim */
  NIMSDK_GET_HISTORY_MESSAGELIST = 'NIMSDK_GET_HISTORY_MESSAGELIST',
  NIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST = 'NIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST',
  NIMSDK_DATA_DYNAMIC_UPDATE = 'NIMSDK_DATA_DYNAMIC_UPDATE',
  NIMSDK_RECEIVEMESSAGE = 'NIMSDK_RECEIVEMESSAGE',
  NIMSDK_SEND_IMTXT_MESSAGE = 'NIMSDK_SEND_IMTXT_MESSAGE',
  NIMSDK_SEND_IMIMAGE_MESSAGE = 'NIMSDK_SEND_IMIMAGE_MESSAGE',
}

/****** action creator ******/

// TIM 一级数据动态更新
export const timSdkDataDynamicUpdate = (payload?: object) => ({
  type: ImActionTypes.TIMSDK_DATA_DYNAMIC_UPDATE,
  payload,
});

// 更新TIM SDK配置信息
export const timSdkUpdateConfig = (payload?: object) => ({
  type: ImActionTypes.TIMSDK_UPDATE_CONFIG,
  payload,
});

//退出
export const timSdkLogout = (payload?: object) => ({
  type: ImActionTypes.TIMSDK_LOGOUT,
  payload,
});

// TIM SDK接收消息
export const timSdkReceiveMessage = (payload, triggerScroll) => {
  // console.log('IM 接收消息', payload);
  let { name = '', data = [] } = payload || {};
  if (name !== 'onMessageReceived') {
    return {
      type: '',
    };
  }
  return {
    type: ImActionTypes.TIMSDK_RECEIVEMESSAGE,
    data: {
      list: data,
      triggerScroll,
    },
  };
};

// TIM SDK 获取群组列表
export const timSdkGetGroupList = (payload) => {
  return {
    type: ImActionTypes.TIMSDK_GET_GROUPLIST,
    payload,
  };
};

// TIM SDK 获取群历史消息列表
export const timSdkGetHistoryMessageList = (payload) => {
  return {
    type: ImActionTypes.TIMSDK_GET_HISTORY_MESSAGELIST,
    payload,
  };
};

// 发送文本消息
export const timSendIMTxtMessage = (payload) => ({
  type: ImActionTypes.TIMSDK_SEND_IMTXT_MESSAGE,
  payload,
});

// 发送图片消息
export const timSendIMImageMessage = (payload) => ({
  type: ImActionTypes.TIMSDK_SEND_IMIMAGE_MESSAGE,
  payload,
});
//更新某条消息的发送状态
export const updateIMMessageStatus = (payload) => ({
  type: ImActionTypes.TIMSDK_UPDATE_MESSAGE_STATUS,
  payload,
});

/*********************网易云信***************************/

// NIM SDK 获取群历史消息列表
export const nimSdkGetHistoryMessageList = (payload) => {
  return {
    type: ImActionTypes.NIMSDK_GET_HISTORY_MESSAGELIST,
    payload,
  };
};
export const nimSdkDataDynamicUpdate = (payload?: object) => ({
  type: ImActionTypes.NIMSDK_DATA_DYNAMIC_UPDATE,
  payload,
});

// NIM SDK接收消息
export const nimSdkReceiveMessage = (payload, triggerScroll) => {
  // console.log('NIM 接收消息', payload);
  return {
    type: ImActionTypes.NIMSDK_RECEIVEMESSAGE,
    data: {
      list: payload,
      triggerScroll,
    },
  };
};

// 发送文本消息
export const nimSendIMTxtMessage = (payload) => ({
  type: ImActionTypes.NIMSDK_SEND_IMTXT_MESSAGE,
  payload,
});
// 发送图片消息
export const nimSendIMImageMessage = (payload) => ({
  type: ImActionTypes.NIMSDK_SEND_IMIMAGE_MESSAGE,
  payload,
});

